<template>
  <div class="page">
    <headerBars_code v-if="$store.state.showInstitutionNav" types="school"  :schoolInfo="$store.state.institutionInfo"></headerBars_code>
    <headerBars_code v-else></headerBars_code>
    <div class="main"  ref="mains">
        <router-view name="default"></router-view>
        <!-- <footerSelf v-if="$route.name != 'home' && $route.name != 'organizationDetail' && $route.name != 'viewGrades' && $route.name != 'learnReport'"></footerSelf> -->
        <Footer :showContactInfo="$route.name == 'home' || $route.name=='settled'"></Footer>
    </div>
  </div>
</template>
<script>
import headerBars_code from '@/page/Common/Header/headerBar_code';
// import footerSelf from '@/components/footer/footer';
import Footer from '@/components/newFooter/footer.vue';

export default {
  data() {
    return {
      isHomeText:false,
      isFoxtip: true,
    }
  },
  created() {
    this.isHome(this.$route.meta.navType);
  },
  mounted() {
    if (new RegExp("/Mobi|Android|webOS|iPhone|iPod|BlackBerry/i").test(navigator.userAgent)) {
      this.isFoxtip = false
    } else {
      this.isFoxtip = true //pc
    }
  },
  components:{
    headerBars_code,Footer
  },
  methods:{
    isHome(navType){
      if(navType=='home'){
        this.isHomeText = true
      }else{
         this.isHomeText = false
      }
    }
  },
  filters:{

  },
  watch: {
    $route(to,form){
      this.isHome(to.meta.navType);
      if(this.isFoxtip){
          this.$nextTick(() => {
            this.$refs.mains.scrollTop = 0;
          });
      }
    }
  },
}

</script>
<style lang="scss" scoped>
@import '~@/assets/css/homepage/index/indexVersion2.scss';
.page{
  position: relative;
}
</style>
<style lang="scss" scoped>
    body {
    .select-poppers.el-select-dropdown{
        .el-select-dropdown__item{
          height:28px;
          line-height:28px;
        }
      }
      .select-poppers.el-dropdown-menu{
        .el-dropdown-menu__item{
          height:28px;
          line-height:28px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/Public/Index/index.vue